import * as React from "react"

import "../styles/font.css"
import "../styles/globals.css"

const RootElement = ({ children }) => <>{children}</>

export default RootElement
